'use client';

import { SplitScreenComponent } from '@payments-checkout/shared/components';
import { useParams } from 'next/navigation';
import { usePageSharedData } from '../../../hooks/usePageSharedData';
import { DeliveryForm } from '../../forms/deliveryForm';
import { LoadingState } from '../../loading';
import { CheckoutDetailsPage } from '../checkoutDetailsPage/checkoutDetailsPage';

export function DeliveryPage() {
  const params = useParams<{ paymentLinkId: string }>();
  const { isReady, paymentLinkIdData } = usePageSharedData();

  if (paymentLinkIdData.isLoading) return <LoadingState fullPage />;

  if (!isReady || !paymentLinkIdData.data) return null;

  return (
    <SplitScreenComponent
      leftContent={<DeliveryForm paymentLinkId={params.paymentLinkId} />}
      rightContent={
        <CheckoutDetailsPage
          accountName={paymentLinkIdData.data.account_settings.account_name}
          displayName={paymentLinkIdData.data.account_settings.display_name}
          organization={paymentLinkIdData.data.account_settings.organization}
          screen="endereco_entrega"
        />
      }
    />
  );
}
